export default {
  infoQr: (state) => state.infoQr
};
